var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandlord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 17.3334H5.33317V20H7.99984V17.3334H10.6665V20H13.3332V17.3334H15.9998V20H18.6665V13.3334L22.6665 9.33337V1.33337H25.3332L30.6665 4.00004L25.3332 6.66671V9.33337L29.3332 13.3334V29.3334H14.6665V25.3334C14.6665 24.6261 14.3856 23.9479 13.8855 23.4478C13.3854 22.9477 12.7071 22.6667 11.9998 22.6667C11.2926 22.6667 10.6143 22.9477 10.1142 23.4478C9.61412 23.9479 9.33317 24.6261 9.33317 25.3334V29.3334H2.6665V17.3334ZM23.9998 13.3334C23.2665 13.3334 22.6665 14.0534 22.6665 14.9334V17.3334H25.3332V14.9334C25.3332 14.0534 24.7332 13.3334 23.9998 13.3334Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandlord);
export default __webpack_public_path__ + "static/media/landlord.381350dadb4abb99b0bda8bd40430584.svg";
export { ForwardRef as ReactComponent };